import React, { Fragment, useState } from 'react';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { Cell } from 'src/components/Cell';
import { Group } from 'src/components/Group';
import { Switch } from 'src/components/Switch';

const Example1 = () => {
  const [value, toggle] = useState(true);

  return (
    <Fragment>
      <PanelHeader>🎚 Switch</PanelHeader>
      <Group separator={false}>
        <Cell after={<Switch value={value} onValueChange={() => toggle(!value)} />} disabled>
          Push Notifications
        </Cell>
        <Cell after={<Switch value={!value} onValueChange={() => toggle(!value)} />} disabled>
          Email Digest
        </Cell>
        <Cell after={<Switch value={true} disabled />} disabled>
          2FA
        </Cell>
        <Cell after={<Switch value={false} disabled />} disabled>
          SMS Notifications
        </Cell>
      </Group>
    </Fragment>
  );
};

storiesOf('Switch', module).add('Default', () => <Example1 />);
